import { render, staticRenderFns } from "./PmCrud.vue?vue&type=template&id=051fdd4e"
import script from "./PmCrud.vue?vue&type=script&lang=js"
export * from "./PmCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports